module.exports = __webpack_public_path__ + "static/bg-showcase-2-6439bbf3ae1d10746d97e57d82e235bc.jpg";